/* eslint-disable max-len */
import React from 'react'

import { string } from 'prop-types'

function CircledArrowRight(props) {
  return (
    <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_13162_166551)">
        <circle cx="12" cy="12" r="12" fill="white" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16.7501 12C16.7501 11.8011 16.6711 11.6104 16.5305 11.4697L13.8638 8.80304L13.3335 8.27271L12.2728 9.33337L12.8031 9.8637L14.1895 11.25L8.00012 11.25H7.25012L7.25012 12.75L8.00012 12.75H14.1895L12.8031 14.1364L12.2728 14.6667L13.3335 15.7274L13.8638 15.197L16.5305 12.5304C16.6711 12.3897 16.7501 12.1989 16.7501 12Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_13162_166551">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}

CircledArrowRight.propTypes = {
  className: string,
  height: string,
  width: string,
}

export default CircledArrowRight
